
import React from 'react';
import { Gradient } from '../Gradient';

const Chart = ({ type, className = '', color = '#737373' }) => {
  return (
    
    <svg xmlns="http://www.w3.org/2000/svg" 
        width="24"
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
        strokeWidth="1.5"
        strokeLinecap="round"
        className={className} 
        >
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
    <polyline points="16 7 22 7 22 13"></polyline>
    <Gradient className={className} />
    </svg>

  );
};

export default Chart;